<style>

    html, body {
        position: relative;
        height: 100%;
        font-size: 12px;
    }

    body:after{
        background-image: url(../imgs/culture_nh/bg.jpg);
    }

    .content-style {
        padding: 0 20px 0 20px;
    }
    @media (min-width: 768px) {
        .content-style {
            padding: 0 20px 0 20px;
        }
    }
    @media (min-width: 992px) {
        .content-style {
            padding: 0 0 80px 0;
        }
    }

    .item-padding-left {
        padding: 0 0 30px 0;
    }
    @media (min-width: 768px) {
        .item-padding-left {
            padding: 0 15px 20px 0;
        }
    }
    @media (min-width: 992px) {
        .item-padding-left {
            padding: 0 20px 20px 20px;
        }
    }
    @media (min-width: 1200px) {
        .item-padding-left {
            padding: 0 20px 20px 20px;
        }
    }

    .item-padding-right {
        padding: 0 0 30px 0;
    }
    @media (min-width: 768px) {
        .item-padding-right {
            padding: 0 0 20px 15px;
        }
    }
    @media (min-width: 992px) {
        .item-padding-right {
            padding: 0 20px 20px 20px;
        }
    }
    @media (min-width: 1200px) {
        .item-padding-right {
            padding: 0 20px 20px 20px;
        }
    }

    .item {
        background: #FFFFFF;
        box-shadow: 0 2px 4px 0 rgba(0,0,0,0.50);
    }

    .item_height_zh {
        height: auto;
    }

    .item_height2_zh {
        height: auto;
    }
    @media (min-width: 768px) {
        .item_height2_zh {
            height: 455px;
        }
    }
    @media (min-width: 992px) {
        .item_height2_zh {
            height: 590px;
        }
    }
    @media (min-width: 1200px) {
        .item_height2_zh {
            height: 590px;
        }
    }

    .item_height_en {
        height: auto;
    }
    @media (min-width: 992px) {
        .item_height_en {
            height: 350px;
            /*height: 240px;*/
        }
    }
    @media (min-width: 1200px) {
        .item_height_en {
            height: 350px;
            /*height: 220px;*/
        }
    }


    .item-detail {
        padding: 25px 25px 25px 25px;
    }

    .item-detail2 {
        padding: 25px 25px 25px 25px;
    }
    @media (min-width: 768px) {
        .item-detail2 {
            padding: 70px 25px 90px 25px;
        }
    }
    @media (min-width: 992px) {
        .item-detail2 {
            padding: 90px 25px 110px 25px;
        }
    }
    @media (min-width: 1200px) {
        .item-detail2 {
            padding: 90px 25px 110px 25px;
        }
    }

    .item-detail3 {
        padding: 25px 0 25px 0;
    }
    @media (min-width: 768px) {
        .item-detail3 {
            padding: 35px 30px 42px 30px;
        }
    }
    @media (min-width: 992px) {
        .item-detail3 {
            padding: 60px 25px 66px 25px;
        }
    }
    @media (min-width: 1200px) {
        .item-detail3 {
            padding: 60px 25px 75px 25px;
        }
    }

    .item-title {
        padding: 14px 10px 10px 20px;
        background-color: #F3F5F7;
        color: #4A4A4A;
        font-size: 13px;
    }
    @media (min-width: 768px) {
        .item-title {
            padding: 25px;
            background-color: #F3F5F7;
            color: #4A4A4A;
            font-size: 14px;
        }
    }
    @media (min-width: 992px) {
        .item-title {
            padding: 25px;
            background-color: #F3F5F7;
            color: #4A4A4A;
            font-size: 20px;
        }
    }
    @media (min-width: 1200px) {
        .item-title {
            padding: 25px;
            background-color: #F3F5F7;
            color: #4A4A4A;
            font-size: 20px;
        }
    }

    .item-subtitle {
        padding: 0 30px 0 30px;
        color: #4A4A4A;
        font-size: 13px;
        font-weight: bold;
    }
    @media (min-width: 768px) {
        .item-subtitle {
            padding: 0;
            color: #4A4A4A;
            font-size: 14px;
            font-weight: bold;
        }
    }
    @media (min-width: 992px) {
        .item-subtitle {
            padding: 0 20px 0 20px;
            color: #4A4A4A;
            font-size: 16px;
            font-weight: bold;
        }
    }
    @media (min-width: 1200px) {
        .item-subtitle {
            padding: 0 20px 0 20px;
            color: #4A4A4A;
            font-size: 18px;
            font-weight: bold;
        }
    }

    .item-text {
        padding: 10px 30px 0 30px;
        color: #4A4A4A;
        font-size: 13px;
        line-height: 160%;
    }
    @media (min-width: 768px) {
        .item-text {
            padding: 20px 0 0 0;
            color: #4A4A4A;
            font-size: 14px;
            line-height: 170%;
        }
    }
    @media (min-width: 992px) {
        .item-text {
            padding: 20px;
            color: #4A4A4A;
            font-size: 16px;
            line-height: 170%;
        }
    }
    @media (min-width: 1200px) {
        .item-text {
            padding: 20px;
            color: #4A4A4A;
            font-size: 18px;
            line-height: 170%;
        }
    }

    .item-title-icon {
        margin-right: 18px;
        margin-bottom: 5px;
    }

    .item-splitter {
        display: none;
        margin: 15px 0 15px 0;
        width: 40px;
        border-bottom: 5px solid #D3A571;
    }


    .section-title {
        color: #FFFFFF;
        margin: 20px 0 10px 0;
        font-size: 16px;
    }
    @media (min-width: 768px) {
        .section-title {
            font-size: 20px;
        }
    }
    @media (min-width: 992px) {
        .section-title {
            margin: 20px 20px 10px 20px;
            font-size: 20px;
        }
    }
    @media (min-width: 1200px) {
        .section-title {
            margin: 20px 20px 10px 20px;
            font-size: 26px;
        }
    }

    .section-subtitle {
        color: #FFFFFF;
        margin: 0 0 20px 0;
        font-size: 14px;
    }
    @media (min-width: 768px) {
        .section-subtitle {
            margin: 0 0 20px 0;
            font-size: 18px;
        }
    }
    @media (min-width: 992px) {
        .section-subtitle {
            margin: 0 20px 20px 20px;
            font-size: 18px;
        }
    }
    @media (min-width: 1200px) {
        .section-subtitle {
            margin: 0 20px 20px 20px;
            font-size: 20px;
        }
    }

    .image-padding {
        padding: 20px 0 0 0;
    }
    @media (min-width: 768px) {
        .image-padding {
            padding: 20px 0 0 0;
        }
    }
    @media (min-width: 992px) {
        .image-padding {
            padding: 20px 0 0 0;
        }
    }
    @media (min-width: 1200px) {
        .image-padding {
            padding: 20px 0 0 0;
        }
    }

    .image-width {
        width: 100%;
        height: 300px;
        object-fit: cover;
    }

    .bottom-style {
        margin: 40px 0 20px 0;
    }
    @media (min-width: 768px) {
        .bottom-style {
            margin: 60px 0 80px 0;
        }
    }

</style>

<template>
    <div class="container">
        <div class="tx-page-title">历届年会</div>
        <!--改造一-->
        <div class="container-fluid content-style">
            <!--2025年会 · 广州-->
            <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 item-padding-left">
                <div class="item item_height_zh">
                    <div>
                        <div class="item-title"><img src="imgs/principle_icon_2.png" alt="" class="item-title-icon">
                            2025年会 · 广州
                        </div>
                        <div class="item-splitter"></div>
                        <div class="item-detail" align="middle">
                            <img src="imgs/culture_nh/2025.jpg" alt="" class="image-width">
                        </div>

                    </div>
                </div>
            </div>
            <!--2024年会 · 曼谷-->
            <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 item-padding-left">
                <div class="item item_height_zh">
                    <div>
                        <div class="item-title"><img src="imgs/principle_icon_2.png" alt="" class="item-title-icon">
                            2024年会 · 曼谷
                        </div>
                        <div class="item-splitter"></div>
                        <div class="item-detail" align="middle">
                            <img src="imgs/culture_nh/2024.jpg" alt="" class="image-width">
                        </div>

                    </div>
                </div>
            </div>
            <!--2023年会 · 广州-->
            <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 item-padding-left">
                <div class="item item_height_zh">
                    <div>
                        <div class="item-title"><img src="imgs/principle_icon_2.png" alt="" class="item-title-icon">
                            2023年会 · 广州
                        </div>
                        <div class="item-splitter"></div>
                        <div class="item-detail" align="middle">
                            <img src="imgs/culture_nh/2023.jpg" alt="" class="image-width">
                        </div>

                    </div>
                </div>
            </div>
            <!--2022年会 · 广州-->
            <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 item-padding-left">
                <div class="item item_height_zh">
                    <div>
                        <div class="item-title"><img src="imgs/principle_icon_2.png" alt="" class="item-title-icon">
                            2022年会 · 广州
                        </div>
                        <div class="item-splitter"></div>
                        <div class="item-detail" align="middle">
                            <img src="imgs/culture_nh/2022.jpg" alt="" class="image-width">
                        </div>

                    </div>
                </div>
            </div>
            <!--2021年会 · 广州-->
            <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 item-padding-right">
                <div class="item item_height_zh">
                    <div>
                        <div class="item-title"><img src="imgs/principle_icon_2.png" alt="" class="item-title-icon">
                            2021年会 · 广州
                        </div>
                        <div class="item-splitter"></div>

                        <div class="item-detail" align="middle">
                            <img src="imgs/culture_nh/2021.jpg" alt="" class="image-width">
                        </div>
                    </div>
                </div>
            </div>
            <!--2020年会 · 成都-->
            <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 item-padding-left">
                <div class="item item_height_zh">
                    <div>
                        <div class="item-title"><img src="imgs/principle_icon_2.png" alt="" class="item-title-icon">
                            2020年会 · 成都
                        </div>
                        <div class="item-splitter"></div>
                        <div class="item-detail" align="middle">
                            <img src="imgs/culture_nh/2020.jpg" alt="" class="image-width">
                        </div>

                    </div>
                </div>
            </div>
            <!--2019年会 · 新加坡-->
            <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 item-padding-right">
                <div class="item item_height_zh">
                    <div>
                        <div class="item-title"><img src="imgs/principle_icon_2.png" alt="" class="item-title-icon">
                            2019年会 · 新加坡
                        </div>
                        <div class="item-splitter"></div>

                        <div class="item-detail" align="middle">
                            <img src="imgs/culture_nh/2019.jpg" alt="" class="image-width">
                        </div>
                    </div>
                </div>
            </div>
            <!--2018年会 · 澳门-->
            <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 item-padding-left">
                <div class="item item_height_zh">
                    <div>
                        <div class="item-title"><img src="imgs/principle_icon_2.png" alt="" class="item-title-icon">
                            2018年会 · 澳门
                        </div>
                        <div class="item-splitter"></div>
                        <div class="item-detail" align="middle">
                            <img src="imgs/culture_nh/2018.jpg" alt="" class="image-width">
                        </div>

                    </div>
                </div>
            </div>
            <!--2017年会 · 东京-->
            <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 item-padding-right">
                <div class="item item_height_zh">
                    <div>
                        <div class="item-title"><img src="imgs/principle_icon_2.png" alt="" class="item-title-icon">
                            2017年会 · 东京
                        </div>
                        <div class="item-splitter"></div>

                        <div class="item-detail" align="middle">
                            <img src="imgs/culture_nh/2017.jpg" alt="" class="image-width">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    module.exports = {
        computed: {
            item_height: function () {
                return {
                    item_height_zh: this.$i18n.locale != 'en_US',
                    item_height_en: this.$i18n.locale == 'en_US',
                }
            }
        },
        mounted: function () {
            $('.item-detail').viewer({
                scalable: false,
                title: false,
                url: 'data-original'
            });
            window.pageTitle = {
                en_US: this.$i18n.messages.en_US.page_title_culture,
                zh_HK: this.$i18n.messages.zh_HK.page_title_culture,
                zh_CN: this.$i18n.messages.zh_CN.page_title_culture
            };
            window.setTitle(window.pageTitle[this.$i18n.locale]);
        }
    }

</script>


// WEBPACK FOOTER //
// culture_nh.vue?77cd0414